import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import {
  Button, Field, Form, Tabbar, TabbarItem, NavBar, Toast, Swipe, SwipeItem,
  NoticeBar, Tab, Tabs, Dialog, Cell, CellGroup, Progress, Empty, Icon,
  Stepper, Popup, ActionSheet, Radio, RadioGroup, Uploader, Loading
} from 'vant'
import './styles/index.scss'

Vue.use(Button).use(Field).use(Form).use(Tabbar).use(TabbarItem).use(NavBar)
  .use(Toast).use(Swipe).use(SwipeItem).use(NoticeBar).use(Tab).use(Tabs)
  .use(Dialog).use(Cell).use(CellGroup).use(Progress).use(Empty).use(Icon)
  .use(Stepper).use(Popup).use(ActionSheet).use(Radio).use(RadioGroup).use(Uploader)
  .use(Loading)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
